import type React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { SeoPanel } from "./SeoPanel";
import type { Lang } from "./LangToggle";

export type EntityTab = "content" | "seo" | "media";

export function EntityTabs({
  content,
  seoPath,
  previewPath,
  media,
  locale,
  defaultTab = "content",
  value,
  onValueChange,
  seoDisabled = false,
}: {
  content: React.ReactNode;
  seoPath: string;
  /** Google önizlemesinde gösterilecek yol; verilmezse seoPath (ör. EN slug farklıysa) */
  previewPath?: string;
  media?: React.ReactNode;
  locale: Lang;
  defaultTab?: EntityTab;
  /** Kontrollü kullanım: form doğrulaması hatada ilgili sekmeye geçebilsin */
  value?: EntityTab;
  onValueChange?: (tab: EntityTab) => void;
  /** Yeni kayıtta SEO sekmesi kapalı: henüz var olmayan slug'a SEO kaydı yetim kalır */
  seoDisabled?: boolean;
}) {
  const controlled =
    value !== undefined
      ? { value, onValueChange: (v: string) => onValueChange?.(v as EntityTab) }
      : { defaultValue: defaultTab };

  return (
    <Tabs {...controlled}>
      <div className="flex flex-wrap items-center gap-3">
        <TabsList>
          <TabsTrigger value="content">İçerik</TabsTrigger>
          <TabsTrigger value="seo" disabled={seoDisabled}>
            SEO
          </TabsTrigger>
          {media !== undefined && <TabsTrigger value="media">Görsel</TabsTrigger>}
        </TabsList>
        {seoDisabled && (
          <span className="text-xs text-muted-foreground">
            SEO ayarları için önce kaydı oluşturun.
          </span>
        )}
      </div>

      {/* forceMount: içerikteki <form> her sekmede DOM'da kalmalı; yoksa
          dışarıdaki form="..." bağlantılı Kaydet butonu diğer sekmelerde çalışmaz. */}
      <TabsContent value="content" forceMount className="data-[state=inactive]:hidden">
        {content}
      </TabsContent>

      <TabsContent value="seo">
        {!seoDisabled && seoPath && !seoPath.endsWith("/") ? (
          <SeoPanel path={seoPath} previewPath={previewPath} locale={locale} />
        ) : (
          <div className="rounded-md border border-dashed border-border p-6 text-sm text-muted-foreground">
            SEO ayarlarını düzenlemek için önce içeriği bir slug ile kaydedin.
          </div>
        )}
      </TabsContent>

      {media !== undefined && (
        <TabsContent value="media" forceMount className="data-[state=inactive]:hidden">
          {media}
        </TabsContent>
      )}
    </Tabs>
  );
}
